/* src/app/front-layout/elevenplus-helpclub/elevenplus-helpclub.component.css */
:host {
  --primary-color: #00729d;
  --secondary-color: #ffbf00;
  --white: #ffffff;
  --light-bg: #f8f9fa;
  --text-dark: #2c3e50;
  --text-gray: #5a6c7d;
  --shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.15);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
section {
  padding: 60px 20px;
}
.container {
  max-width: 1400px;
  margin: 0 auto;
}
.section-title {
  font-size: 3.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.section-intro,
.section-text {
  font-size: 2rem;
  color: var(--text-gray);
  text-align: center;
  max-width: 1200px;
  margin: 0 auto 40px;
  line-height: 1.8;
}
.hero-section {
  background:
    linear-gradient(
      135deg,
      var(--primary-color) 0%,
      #005577 100%);
  color: var(--white);
  padding: 80px 20px;
  text-align: center;
  align-items: center;
}
.hero-content {
  max-width: 1400px;
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
}
.hero-badge {
  display: inline-block;
  background: white;
  color: var(--primary-color);
  padding: 8px 24px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 2rem;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.hero-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  color: white;
}
.hero-subtitle {
  font-size: 2.2rem;
  margin-bottom: 20px;
  font-weight: 500;
  opacity: 0.95;
}
.hero-description {
  font-size: 1.8rem;
  line-height: 1.8;
  margin-bottom: 40px;
  opacity: 0.9;
}
.hero-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}
.highlight-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease, background 0.3s ease;
}
.highlight-item:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.15);
}
.highlight-item.highlight-free {
  background: var(--secondary-color);
  color: var(--primary-color);
  font-weight: 700;
}
.highlight-item .icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.highlight-item span {
  font-size: 1.8rem;
  font-weight: 500;
}
.cta-button {
  background: var(--secondary-color);
  color: var(--primary-color);
  border: none;
  padding: 18px 40px;
  font-size: 1.8rem;
  font-weight: 700;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 191, 0, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 191, 0, 0.4);
  background: #ffc61a;
}
.cta-button-large {
  padding: 20px 50px;
  font-size: 1.8rem;
}
.what-is-section {
  background: var(--white);
}
.motto {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  background:
    linear-gradient(
      135deg,
      var(--primary-color) 0%,
      #005577 100%);
  color: var(--white);
  padding: 30px;
  border-radius: 15px;
  max-width: 700px;
  margin: 40px auto 0;
  box-shadow: var(--shadow-lg);
}
.motto-icon {
  font-size: 2.5rem;
}
.motto-text {
  font-size: 2rem;
  font-weight: 600;
  font-style: italic;
  margin: 0;
}
.exams-section {
  background: var(--light-bg);
}
.exams-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}
.exam-card {
  background: var(--white);
  padding: 40px 30px;
  border-radius: 15px;
  text-align: center;
  box-shadow: var(--shadow);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 3px solid transparent;
}
.exam-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--secondary-color);
}
.exam-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}
.exam-card h3 {
  font-size: 1.8rem;
  color: var(--primary-color);
  font-weight: 700;
}
.exams-footer {
  text-align: center;
  font-size: 1.5rem;
  color: var(--text-gray);
  max-width: 700px;
  margin: 0 auto;
  font-style: italic;
}
.benefits-section {
  background: var(--white);
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}
.benefit-card {
  background: var(--light-bg);
  padding: 35px 25px;
  border-radius: 15px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 5px solid var(--primary-color);
}
.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
}
.benefit-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
.benefit-icon svg {
  width: 100%;
  height: 100%;
  stroke: var(--white);
  stroke-width: 2;
}
.benefit-card h3 {
  font-size: 2rem;
  color: var(--primary-color);
  margin-bottom: 15px;
  font-weight: 700;
}
.benefit-card p {
  font-size: 1.5rem;
  color: var(--text-gray);
  line-height: 1.6;
}
.why-year4-section {
  background:
    linear-gradient(
      135deg,
      var(--primary-color) 0%,
      #005577 100%);
  color: var(--white);
}
.why-year4-section .section-title {
  color: var(--white);
}
.why-year4-section .section-intro {
  color: var(--white);
  font-size: 2rem;
  opacity: 0.95;
}
.reasons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}
.reason-item {
  background: rgba(255, 255, 255, 0.1);
  padding: 30px;
  border-radius: 15px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, background 0.3s ease;
}
.reason-item:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.15);
}
.reason-number {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  background: var(--secondary-color);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 800;
}
.reason-item p {
  font-size: 1.5rem;
  line-height: 1.6;
  margin: 0;
  padding-top: 10px;
}
.year4-footer {
  background: rgba(255, 255, 255, 0.15);
  padding: 25px;
  border-radius: 15px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  border: 2px solid rgba(255, 191, 0, 0.3);
}
.year4-footer p {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}
.who-section {
  background: var(--light-bg);
}
.who-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
}
.who-card {
  background: var(--white);
  padding: 35px 25px;
  border-radius: 15px;
  text-align: center;
  box-shadow: var(--shadow);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-top: 4px solid var(--secondary-color);
}
.who-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
}
.who-icon {
  font-size: 3.5rem;
  margin-bottom: 20px;
}
.who-card p {
  font-size: 1.5rem;
  color: var(--text-dark);
  line-height: 1.6;
  font-weight: 500;
}
.why-choose-section {
  background: var(--white);
}
.choose-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}
.choose-card {
  background: var(--light-bg);
  padding: 35px 25px;
  border-radius: 15px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 3px solid transparent;
}
.choose-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-color);
}
.choose-icon {
  font-size: 3.5rem;
  margin-bottom: 20px;
}
.choose-card h3 {
  font-size: 2rem;
  color: var(--primary-color);
  margin-bottom: 15px;
  font-weight: 700;
}
.choose-card p {
  font-size: 1.5rem;
  color: var(--text-gray);
  line-height: 1.6;
}
.focus-statement {
  background:
    linear-gradient(
      135deg,
      var(--primary-color) 0%,
      #005577 100%);
  color: var(--white);
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  box-shadow: var(--shadow-lg);
}
.focus-statement p {
  font-size: 2rem;
  font-weight: 600;
  font-style: italic;
  margin: 0;
}
.final-cta-section {
  background:
    linear-gradient(
      135deg,
      #005577 0%,
      var(--primary-color) 100%);
  color: var(--white);
  padding: 80px 20px;
}
.final-cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}
.final-cta-content h2 {
  font-size: 2.8rem;
  margin-bottom: 20px;
  font-weight: 700;
  color: white;
}
.final-cta-content > p {
  font-size: 2rem;
  margin-bottom: 35px;
  opacity: 0.95;
}
.cta-subtext {
  margin-top: 25px;
  font-size: 1.5rem;
  opacity: 0.9;
  font-weight: 500;
}
@media (max-width: 768px) {
  .section-title {
    font-size: 3rem;
  }
  .hero-title {
    font-size: 3.5rem;
  }
  .hero-subtitle {
    font-size: 1.8rem;
  }
  .hero-highlights {
    grid-template-columns: 1fr;
  }
  .benefits-grid,
  .reasons-grid,
  .who-grid,
  .choose-grid {
    grid-template-columns: 1fr;
  }
  .exams-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .motto {
    flex-direction: column;
    text-align: center;
  }
  .motto-text {
    font-size: 1.5rem;
  }
  .final-cta-content h2 {
    font-size: 2rem;
  }
  section {
    padding: 40px 20px;
  }
}
@media (max-width: 480px) {
  .hero-title {
    font-size: 3rem;
  }
  .section-title {
    font-size: 2.5rem;
  }
  .exams-grid {
    grid-template-columns: 1fr;
  }
  .exams-footer {
    font-size: 1rem;
  }
  .cta-button {
    padding: 15px 30px;
    font-size: 1.5rem;
  }
  .cta-button-large {
    padding: 16px 35px;
    font-size: 1.5rem;
  }
}
/*# sourceMappingURL=elevenplus-helpclub.component.css.map */
